import { EffectType } from "@1games-ru/region-shared/dist/enums/effect/effect";
import { AnimatePresence } from "motion/react";
import { useMemo } from "react";
import clsx from "clsx";
import useAppSelector from "@/core/helpers/useAppSelector";
import { playerInfoSelector } from "@/domains/player/slice";
import HudEffectType from "@/domains/hud/components/HudEffectType";

export default function HudEffectsContainer() {
  const playerInfo = useAppSelector(playerInfoSelector);

  const reducedEffects = useMemo(() => {
    const effects: { effect: EffectType; startedAt?: number; finishedAt?: number }[] = [];

    Object.values(playerInfo?.character?.vitals || []).forEach((value) => {
      value.effects.forEach((item) => {
        if (!effects.find((effect) => effect.effect === item.type)) {
          effects.push({
            effect: item.type,
            startedAt: item.startedAt,
            finishedAt: item.finishedAt,
          });
        }
      });
    });

    return effects;
  }, [playerInfo]);

  if (!playerInfo?.character) return null;

  return (
    <div className={clsx("flex items-center gap-1.5")}>
      <AnimatePresence initial={false}>
        {reducedEffects.map((item) => (
          <HudEffectType key={item.effect} {...item} />
        ))}
      </AnimatePresence>
    </div>
  );
}
